module.exports = __webpack_public_path__ + "static/media/bath-body.e924f089.webp";